import { getProfile } from '../../apiCalls/urlFunction';
import { UPDATE_USER_PROFILE } from '../actionTypes';

export function fetchUserProfile() {
  return async (dispatch) => {
    const userResponse = await getProfile();
    if (userResponse?.status) {
      dispatch(updateUserProfile(userResponse?.data));
    }
  };
}

export function updateUserProfile(payload) {
  return {
    type: UPDATE_USER_PROFILE,
    payload: payload,
  };
}
